import { CALL_API } from 'middlewares/api';
import { NEWTUBE_API_SERVER } from 'configs/url';
import { groupBy } from 'lodash';

const FETCH_PARAMS_REQUEST = 'foundation/mydata/FETCH_PARAMS_REQUEST';
const FETCH_PARAMS_SUCCESS = 'foundation/mydata/FETCH_PARAMS_SUCCESS';
const FETCH_PARAMS_FAIL = 'foundation/mydata/FETCH_PARAMS_FAIL';

export function fetchParams() {
  return {
    [CALL_API]: {
      types: [FETCH_PARAMS_REQUEST, FETCH_PARAMS_SUCCESS, FETCH_PARAMS_FAIL],
      url: `${NEWTUBE_API_SERVER}params`,
    },
  };
}

export default function reducer(state = {
  isLoading: false,
  isLoaded: false,
  data: null,
}, action) {
  switch (action.type) {
    case FETCH_PARAMS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        isLoaded: false,
        data: null,
      });
    case FETCH_PARAMS_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        data: groupBy(action.response.data, 'type'),
      });
    case FETCH_PARAMS_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
      });
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/reducers/paramsReducer.js
 **/